import { DuplicateInvoiceError } from './definitions/duplicate-invoice.error.js';
import { FileTooLargeError } from './definitions/file-too-large.error.js';
import { GenericError } from './definitions/generic.error.js';
import { SharePointProjectNotFoundError } from './definitions/sharepoint-project-not-found.error.js';
import { SharePointProvisioningBusyError } from './definitions/sharepoint-provisioning-busy.error.js';
function buildClientErrors(...errors) {
    return Object.fromEntries(errors.map((error) => [error.type, error]));
}
export const CLIENT_ERRORS = buildClientErrors(DuplicateInvoiceError, GenericError, FileTooLargeError, SharePointProvisioningBusyError, SharePointProjectNotFoundError);
